<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="form"
      @submit="handleUpdate"
      @change="handleFormChange"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import _ from 'lodash';

@Component
export default class CategoriesEdit extends Vue {

  form = {}
  firstLevelCategories = []
  secondLevelCategories = []
  links = []

  get columns() {
    return createColumns({
      isEditPage: true,
      level: this.form.level,
      firstLevelCategories: this.firstLevelCategories,
      secondLevelCategories: this.secondLevelCategories,
      links: this.links
    });
  }

  async mounted() {
    let { category, grouped_links } = await this.$request.get(`/categories/${this.$route.params.id}`);
    this.form = category;
    if (_.get(this.form, 'parent.id')) {
      const [firstLevelCategories, secondLevelCategories] = await Promise.all([
        this.$request.get('/categories', { params: { simple_list: true, level_eq: 'first_level', per_page: 999 } }),
        this.$request.get('/categories', { params: { simple_list: true, level_eq: 'second_level', per_page: 999 } })
      ]);
      this.firstLevelCategories = firstLevelCategories.data;
      this.secondLevelCategories = secondLevelCategories.data;
      if (!grouped_links) {
        grouped_links = await this.$request.get('/page_group_links');
      }
      this.links = _.map(grouped_links, (groupValue, groupLable) => {
        return {
          label: groupLable,
          options: _.map(groupValue, (value, label) => ({ value, label }))
        }
      });
    }
  }

  async handleUpdate(data) {
    const id = this.$route.params.id;
    await this.$autoLoading(
      this.$request.put(`/categories/${id}`, data)
    );
    this.$router.push({ name: 'categories.show', params: { id } });
  }

  handleFormChange(data) {
    this.form = data;
  }
}
</script>
